<script>
import { CustomLocationModal } from '@ibiquity/dashboard.location-selector';

export default {
  name: 'PanelCustomLocationModal',
  extends: CustomLocationModal,
};
</script>


<style lang="scss">
@import "~@/assets/scss/variables";
@import "~@/assets/scss/inputs";
@import "~@/assets/scss/buttons";

.dash-custom-location-modal {
  position: absolute;

  .overlay {
    position: fixed;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .container {
    width: 540px;
    padding: 24px;
    background-color: $charcoal-nero;
    border-radius: $radius;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .header {
    font-size: 25px;
    font-weight: $weight-black;
    color: $white;
    margin-bottom: 30px;
    line-height: 30px;
  }

  .buttons {
    justify-content: space-between;
    margin-top: 40px;
  }
  .coordinates {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  .field {
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    width: 49%;
    & + .field {
      margin-left: 10px;
    }
  }
  label {
    font-size: 13px;
    line-height: 1.23;
    font-weight: $weight-normal;
    color: $grey;
    margin-bottom: 4px;
    display: block;
  }
  .input {
    @extend %input;
    &:invalid {
      border: solid 1px #cc0000;
    }
  }

  button {
    @include button($input-background-color, $charcoal-dark, $white);
    height: 50px;
    width: 200px;
    &.primary {
      @include button($orange, $orange, $white);
      height: 50px;
      width: 200px;
    }
    &.close-button {
      min-width: 13px;
      width: 13px;
      height: 13px;
      border: none;
      background: none;
      padding: 0;
      & .icon {
        margin: 0;
        width: 100%;
      }
    }
  }

  .custom-location-modal-transition-enter, .custom-location-modal-transition-leave-active {
    opacity: 0;
  }

  .custom-location-modal-transition-enter .container,
  .custom-location-modal-transition-leave-active .container {
    transform: scale(1.2);
  }
}

</style>
